// token 解析工具
export default {
  /**
   * 打开微信授权页面
   *
   */
  wechatAuthorize() {
    let params = {
      appid: process.env.VUE_APP_APPID,
      redirect_url: window.location.origin + process.env.VUE_APP_REDIRECT_URI,
      state: Math.floor(Math.random() * (9999 - 1000)) + 1000 //随机四位数
    }
    let url = `${process.env.VUE_APP_WECHAT_BASE_URL}/${process.env.VUE_APP_OAUTH2_AUTHORIZED_URI}?appid=${params.appid}&redirect_url=${params.redirect_url}&response_type=code&scope=snsapi_userinfo&state=${params.state}#wechat_redirect`
    window.location.href = url
  }
}
